import { post } from '~/plugins/nikan-api'
import _ from 'lodash'
import Endpoints from '@nikan/endpoints'

const UNCHANGED = 'unchanged'

const Keys = {
  ADD_SCHEMAS: 'add_schemas',
  SET_ALL_AS_UNCHANGED: 'set_all_as_unchanged',
  CLEAR: 'clear'
}

export const state = {
  schemas: []
}
export const mutations = {
  [Keys.ADD_SCHEMAS](state, schemas) {
    if (!schemas || !schemas.length) {
      return
    }

    state.schemas = schemas
  },

  [Keys.SET_ALL_AS_UNCHANGED](state) {
    for (let schema of state.schemas) {
      schema.rowState = UNCHANGED
    }
  },

  [Keys.CLEAR](state) {
    state.schemas = []
  }
}
export const actions = {
  async getBySubject({ dispatch, commit, state }, subject) {
    if (state.schemas.length == 0) {
      await dispatch('refresh', { force: true })
    }

    return state.schemas.filter(item => item.subject === subject)
  },

  async refresh({ dispatch, commit, state }, options) {
    options = _.extend({ force: false }, options)

    // clear
    commit(Keys.CLEAR)

    var key = 'data-metaDataSchemas'

    if (options.force !== true) {
      var cached = await dispatch('cache/get', key, { root: true })
      if (cached != null) {
        commit(Keys.ADD_SCHEMAS, cached)
        return
      }
    }

    var result = await post(Endpoints.getUrl('metadata.list'), null, null, { preventConcurrent: false })
    if (result.success) {
      var cacheObj = {
        key,
        seconds: 24 * 60 * 60,
        value: result.data.items
      }

      dispatch('cache/set', cacheObj, { root: true })
      commit(Keys.ADD_SCHEMAS, cacheObj.value)
    }
  },

  async modify({ dispatch, commit, state }, schemas) {
    let result = await post(Endpoints.getUrl('metadata.modify'), { items: schemas })
    if (result.success) {
      await dispatch('refresh', { force: true })
    }
  },

  clear({ commit }) {
    commit(Keys.CLEAR)
  }
}
export const getters = {
  schemas: state => {
    return state.schemas
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
